import { CONSTANTS__generation_settings as CONSTANTS, CONSTANTS__generation_settings } from '@shared/constants/CONSTANTS__generation_settings';
import { CONSTANTS_GENERATION__slider_step as CONSTANTS_SLIDER } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range, CONSTANTS_GENERATION__value_range as CONSTANTS_RANGE } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_family, ENUM_UTILS__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD_PRIMITIVE__seed } from '../../_fields/_primitives/FIELD_PRIMITIVE__seed';
import { FIELD_PRIMITIVE__float } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__string_enum } from '../../_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { FIELD__tensor_latents } from '../../_fields/_tensor/FIELD__tensor_latents';
import { DTO_GRAPH__edge_autoconnect_info_list } from '../../_graph/DTO_GRAPH__edge_autoconnect_info_list';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';
import { INVOCATION_SD__denoise_latents_pipeline } from '../sd/denoise/INVOCATION_SD__denoise_latents_pipeline';

const IMAGE_SIZE_PROPERTY = FIELD_PRIMITIVE__int.partial({
  value: 512,
  value_range: CONSTANTS_RANGE.IMAGE_SIZE_IN,
  values_allowed: CONSTANTS_RANGE.IMAGE_SIZE_IN,
  //
  multiple_of: CONSTANTS.IMAGE_SIZE_MULTIPLIER,
  //
  slider_step: CONSTANTS_SLIDER.IMAGE_SIZE_DEFAULT,
  slider_step_values: CONSTANTS_SLIDER.IMAGE_SIZE_VALUES,
});

export class INVOCATION_LATENTS__create_noise extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_LATENTS__CREATE_NOISE;

  /*
   * FIELDS IN
   */

  @FIELD_PRIMITIVE__seed.init_as_input(
    {
      value: CONSTANTS__generation_settings.SEEDS_DEFAULT[0],
      values_allowed: CONSTANTS__generation_settings.SEED_RANGE,
      value_range: CONSTANTS__generation_settings.SEEDS_DEFAULT,
    },
    { field_role: '🎲 Seed' },
  )
  seed!: FIELD_PRIMITIVE__seed;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__ml_asset_family.SD_1, ENUM_UTILS__ml_asset_family.get_enum_generative())
  target_family!: FIELD_PRIMITIVE__string_enum;

  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 1.0,
      value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_10,
      values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_10,
    },
    {
      grid2d__can_be_dimension: false,
      field_role: '📏 Scale',
    },
  )
  scale!: FIELD_PRIMITIVE__float;

  /*
   * FIELDS OUT
   */

  @FIELD__tensor_latents.init_as_output({}, { field_role: '🔮 Noise Latents' })
  out__latents!: FIELD__tensor_latents;

  /*
   * EVENTS
   */

  edges__try_autocreate(graph: DTO_GRAPH__instance) {
    super.edges__try_autocreate(graph);

    /*
     * INVOCATION__noise -> INVOCATION_SD__denoise_latents_pipeline
     */

    let list_to_denoise = new DTO_GRAPH__edge_autoconnect_info_list<INVOCATION_SD__denoise_latents_pipeline>();
    list_to_denoise.invocation_type = INVOCATION_SD__denoise_latents_pipeline;
    list_to_denoise.add(this.seed, ['seed']);
    list_to_denoise.add(this.out__latents, ['noise']);

    this.edges__try_autocreate_from_left_to_right(graph, list_to_denoise);
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.LATENTS__CREATE_NOISE);
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);
  }
}
